const INTERNAL_USER_PROFILE_KEY = "internalUserProfile";

function getSessionStorage(): Storage | null {
    if (typeof window === "undefined") {
        return null;
    }

    return window.sessionStorage;
}

export function getStoredInternalUserProfile<T extends object>(): T | null {
    const storage = getSessionStorage();
    if (!storage) {
        return null;
    }

    try {
        const rawProfile = storage.getItem(INTERNAL_USER_PROFILE_KEY);
        if (!rawProfile) {
            return null;
        }

        const parsedProfile = JSON.parse(rawProfile);
        if (!parsedProfile || typeof parsedProfile !== "object") {
            return null;
        }

        return parsedProfile as T;
    } catch {
        return null;
    }
}

export function setStoredInternalUserProfile(profile: object): void {
    getSessionStorage()?.setItem(
        INTERNAL_USER_PROFILE_KEY,
        JSON.stringify(profile)
    );
}

export function clearStoredInternalUserProfile(): void {
    getSessionStorage()?.removeItem(INTERNAL_USER_PROFILE_KEY);
}

export { INTERNAL_USER_PROFILE_KEY };
